export default "__VITE_ASSET__0071747f__"